"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSwitchField = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
var mobx_1 = require("mobx");
var Switch = core_1.Switch;
var VSwitchField = (function (_super) {
    __extends(VSwitchField, _super);
    function VSwitchField(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e) {
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange(e.target.checked);
            }
            if (_this.props.onChange) {
                _this.props.onChange(e.target.checked);
            }
        };
        return _this;
    }
    VSwitchField.prototype.render = function () {
        var _a = this.props, label = _a.label, labelInfo = _a.labelInfo, fieldState = _a.fieldState, size = _a.size, disabled = _a.disabled, inline = _a.inline, alignIndicator = _a.alignIndicator, id = _a.id, className = _a.className, layer = _a.layer, checkBoxAtLeft = _a.checkBoxAtLeft, noLabel = _a.noLabel, required = _a.required, validators = _a.validators, margin = _a.margin, value = _a.value, labelElement = _a.labelElement, innerLabel = _a.innerLabel, requiredJustVisual = _a.requiredJustVisual, innerLabelChecked = _a.innerLabelChecked, displayRequired = _a.displayRequired, tooltip = _a.tooltip;
        if (fieldState) {
            if (required && !requiredJustVisual) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
        return (react_1.default.createElement(style_1.StyledCheckBoxInput, { className: className, disabled: disabled, inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, checkBoxAtLeft: checkBoxAtLeft, noLabel: noLabel, margin: margin },
            react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
                react_1.default.createElement(Switch, __assign({ name: id, large: size === 'large' }, {
                    disabled: disabled,
                    id: id,
                    inline: inline,
                    alignIndicator: alignIndicator,
                    labelElement: labelElement,
                    innerLabel: innerLabel,
                    innerLabelChecked: innerLabelChecked,
                    label: ''
                }, { onChange: this.onChange, checked: this.valueField })))));
    };
    Object.defineProperty(VSwitchField.prototype, "valueField", {
        get: function () {
            if (this.props.fieldState) {
                return this.props.fieldState.value || false;
            }
            if (this.props.value) {
                return this.props.value;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], VSwitchField.prototype, "valueField", null);
    VSwitchField = __decorate([
        mobx_react_1.observer
    ], VSwitchField);
    return VSwitchField;
}(react_1.default.Component));
exports.VSwitchField = VSwitchField;
